import { render, staticRenderFns } from "./Boutique.vue?vue&type=template&id=bab67dc6&scoped=true&"
import script from "./Boutique.vue?vue&type=script&lang=js&"
export * from "./Boutique.vue?vue&type=script&lang=js&"
import style0 from "./Boutique.vue?vue&type=style&index=0&id=bab67dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab67dc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VSelect,VTextField})
